<div>
  <form
    data-e2e="AnycastForm"
    [formGroup]="form"
    [withoutMarkAllAsTouched]="true"
    (submit)="addPort()">
    <div>
      <div class="w-100 d-flex flex-column gap-2">
        <div class="row align-items-center">
          <div
            class="mb-0 bn-form__label"
            [ngClass]="isInternalIp ? 'col-7 col-sm-8' : 'col'">
            Container port
          </div>
          @if (!isInternalIp) {
            <div
              class="mb-0 bn-form__label"
              [ngClass]="isInternalIp ? 'col-5 col-sm-4' : 'col'">
              Exposed port
            </div>
          }
          <div class="col mb-0 bn-form__label">Protocol</div>
        </div>
        <ng-container formArrayName="portMappings">
          @for (portMapping of portMappings.controls; track portMapping; let i = $index) {
            <div
              class="row"
              [formGroupName]="i"
              (focusout)="setErrors()">
              <div [ngClass]="isInternalIp ? 'pe-3 col-7 col-sm-8' : 'col'">
                <bn-web-ui-input
                  #portInput
                  class="flex-grow-1"
                  data-e2e="AnycastFormContainerPort"
                  formControlName="containerPort"
                  inputName="Port"
                  size="sm"
                  type="number"
                  [hideErrorMessages]="true"
                  [options]="{ hideRequiredLabel: true }" />
              </div>

              @if (!isInternalIp) {
                <div [ngClass]="isInternalIp ? 'col-5 col-sm-4' : 'col'">
                  <bn-web-ui-input
                    class="flex-grow-1"
                    data-e2e="AnycastFormExposedPort"
                    formControlName="exposedPort"
                    inputName="Port"
                    size="sm"
                    type="number"
                    [hideErrorMessages]="true"
                    [options]="{ hideRequiredLabel: true }" />
                </div>
              }

              <div class="col d-inline-flex gap-3 align-items-center">
                <bn-web-ui-checkbox
                  data-e2e="AnycastFormTCPcheckbox"
                  formControlName="tcp"
                  [label]="'TCP'"
                  [withError]="errorsOneObject.includes(i)" />

                <bn-web-ui-checkbox
                  data-e2e="AnycastFormUDPcheckbox"
                  formControlName="udp"
                  [label]="'UDP'"
                  [withError]="errorsOneObject.includes(i)" />

                @if (!isInternalIp && portMappings.controls.length > 1) {
                  <bn-web-ui-button
                    aria-label="Remove Port"
                    class="bn-button--circle bn-button--remove"
                    data-e2e="AnycastFormRemove"
                    itemStyle="stroke"
                    size="sm"
                    title="Remove port"
                    type="button"
                    (click)="removePort(i)">
                    <fa-icon icon="xmark" />
                  </bn-web-ui-button>
                }
              </div>
            </div>
          }
        </ng-container>
      </div>
    </div>
    @if (!isInternalIp) {
      <button
        bn-web-ui-button
        class="mt-4"
        data-e2e="AnycastFormAddNewPort"
        itemStyle="link"
        [disabled]="!form.valid"
        (click)="addPort()">
        Add New Port
      </button>
    }

    @if (form.invalid) {
      @for (error of errorsRequired; track error) {
        <bn-web-ui-formcontrol-errors [withCustomPlaceHolder]="true">
          @if (error === 'containerPort') {
            Container port is required
          }
          @if (error === 'exposedPort') {
            Exposed port is required
          }
        </bn-web-ui-formcontrol-errors>
      }
      @for (error of errorsUnique; track error) {
        <bn-web-ui-formcontrol-errors [withCustomPlaceHolder]="true">
          @if (error === 'containerPort') {
            Container ports must be unique
          }
          @if (error === 'exposedPort') {
            Exposed ports must be unique
          }
        </bn-web-ui-formcontrol-errors>
      }
      @for (error of errorsMax; track error) {
        <bn-web-ui-formcontrol-errors [withCustomPlaceHolder]="true">
          @if (error === 'containerPort') {
            Container port max value is 65535
          }
          @if (error === 'exposedPort') {
            Exposed port max values is 65535
          }
        </bn-web-ui-formcontrol-errors>
      }
      @for (error of errorsMin; track error) {
        <bn-web-ui-formcontrol-errors [withCustomPlaceHolder]="true">
          @if (error === 'containerPort') {
            Container port min value is 1
          }
          @if (error === 'exposedPort') {
            Exposed port min value is 1
          }
        </bn-web-ui-formcontrol-errors>
      }
      @if (errorsOneObject.length > 0) {
        <bn-web-ui-formcontrol-errors customError="At least one protocol is required" />
      }
      <!-- TODO: The validators preceding this one do not require separate error groups.
      They could be consolidated into a single loop that checks against 'allErrors'.
      This would simplify the logic and allow errors to be added directly to this group.
      This would also help to show only one error at the time -->
      @for (error of customPortErrors; track error) {
        <bn-web-ui-formcontrol-errors [customError]="error.message" />
      }
    }
  </form>
</div>
